<template>
  <div class="login-container">
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">Сброс пароля</h2>
      <el-form @submit.prevent="handleResetPassword">
        <el-form-item>
          <el-input
              v-model="username"
              placeholder="Username"
              prefix-icon="el-icon-user"
              autocomplete="off"
              required
          />
        </el-form-item>
        <el-form-item>
          <el-button :loading="isLoading" type="primary" @click="handleResetPassword" block>Сбросить пароль с использованием ЭЦП</el-button>
        </el-form-item>
        <span><i>При успешном сбросе пароль вы на экране увидите временный пароль!</i></span>
        <a href="/login" style="font-size:15px">Назар к страницу авторизаций</a>
      </el-form>
      <p v-if="message" class="error-message">{{ message }}</p>
    </el-card>


    <div v-if="isLoading" class="overlay">
      <div class="overlay-content">
        <el-icon class="is-loading" size="20">
          <Loading />
        </el-icon>
        Пожалуйста, подпишите с помощью ЭЦП и дождитесь ответа от сервера для получения временного пароля.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from "vue";
import signService from "@/services/ncaLayerService";
import {ElMessage} from "element-plus";
import {resetPasswordECP} from "@/services/userService";
import {useRouter} from "vue-router";

export default defineComponent({
  name: "ResetPasswordECP",
  setup() {

    const {signCallback} = signService;
    const username = ref("");
    const message = ref("");
    const isLoading = ref(false);
    const router = useRouter();

    const handleResetPassword = () => {
      if (username.value !== '') {
        isLoading.value = true;
        signService.createCMSSignatureForAuthenticate(onSignAuthCallback, onError);
        isLoading.value = true;
      } else {
        ElMessage({
          message: "Заполните поле Username",
          type: 'warning',
          duration: 0,
          showClose: true,
        });
      }
    };

    const onSignAuthCallback = (response: any) => {
      console.log(response.result);
      if (username.value !== '') {
        resetPasswordECP(username.value, response.result).then((response) => {
          ElMessage({
            message: "Ваш новый временный пароль: " + response.data,
            type: 'success',
            duration: 0,
            showClose: true
          });
          isLoading.value = false;
        }).catch((error) => {
          ElMessage({
            message: error.response.data.message,
            type: 'error',
            duration: 0,
            showClose: true,
          });
          isLoading.value = false;
        });
      } else {
        ElMessage({
          message: "Заполните поле Username",
          type: 'warning',
          duration: 0,
          showClose: true,
        });
        isLoading.value = false;
      }
    }

    const onError = () => {
      console.log("ok5");
      isLoading.value = false;
    }

    onMounted(() => {
      signService.init();
    });

    watch(() => signCallback.callback, (newVal) => {
      if (newVal) {
        newVal(signCallback.result);
      }
    });

    return {
      username,
      message,
      isLoading,
      router,
      handleResetPassword,
    };
  }
});
</script>

<style scope>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 30px;
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
}

.error-message {
  color: red;
  margin-top: 15px;
  text-align: center;
}


.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  z-index: 9999;
}

.overlay-content {
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 8px;
}
</style>